import React, { useState } from "react";
import { Divider, List, ListItem, ListItemText, ListItemIcon, makeStyles } from "@material-ui/core";
import { useIntl } from "react-intl";
import { every, isEmpty } from "lodash";
import { Flaticon, CardItem, VideoDialog } from "../../components";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    overflowX: "auto",
    "& > *": {
      minWidth: theme.spacing(20),
      width: theme.spacing(20),
      marginRight: theme.spacing(1)
    }
  }
}));

const EPosterVideoUrls = ({ ePoster }) => {
  const intl = useIntl();
  const classes = useStyles();
  const [selectedVideoUrl, setSelectedVideoUrl] = useState();

  const videoUrlListItem = videoUrl => (
    <CardItem
      videoUrl={videoUrl}
      title={intl.formatMessage({
        id: "Eposters.EPosterVideoUrls.Presentation",
        defaultMessage: "Presentation"
      })}
      onClick={() => {
        setSelectedVideoUrl(videoUrl);
      }}
    />
  );

  if (every([ePoster.videoUrl1, ePoster.videoUrl2, ePoster.videoUrl3], url => isEmpty(url)))
    return null;
  return (
    <>
      <Divider />
      <List>
        <ListItem>
          <ListItemIcon>
            <Flaticon fontSize="1.5rem" icon="presentation" />
          </ListItemIcon>
          <ListItemText
            primary={
              <strong>
                {intl.formatMessage({
                  id: "Eposters.EPosterVideoUrls.EPosterPresentation",
                  defaultMessage: "E-Poster Presentation"
                })}
              </strong>
            }
            primaryTypographyProps={{ variant: "h6" }}
          />
        </ListItem>
        <ListItem>
          <ListItemIcon />
          <div className={classes.root}>
            {ePoster.videoUrl1 ? videoUrlListItem(ePoster.videoUrl1) : null}
            {ePoster.videoUrl2 ? videoUrlListItem(ePoster.videoUrl2) : null}
            {ePoster.videoUrl3 ? videoUrlListItem(ePoster.videoUrl3) : null}
          </div>
        </ListItem>
      </List>
      {selectedVideoUrl && (
        <VideoDialog
          videoUrl={selectedVideoUrl}
          title={intl.formatMessage({
            id: "Eposters.EPosterVideoUrls.EPosterPresentation",
            defaultMessage: "E-Poster Presentation"
          })}
          onClose={() => {
            setSelectedVideoUrl(null);
          }}
        />
      )}
      <Divider />
    </>
  );
};

export default EPosterVideoUrls;
